import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
// import LanguageIcon from '@mui/icons-material/Language';
import LanguageIcon from '@mui/icons-material/Language';

import { useMediaQuery, Theme, MenuItem, ListItemIcon, IconProps } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import _ from 'lodash';

const useStyles = makeStyles(
  (theme: Theme) => createStyles({
    menuItem: {
      color: theme.palette.text.secondary,

    },
    icon: { minWidth: theme.spacing(5) },
    languageLabel: {
      fontSize:'0.875rem',
      padding: '0 5px 0 0',
      wordBreak: 'keep-all',
    }
  })
  // { name: 'RaLogout' }
);

const LanguageMenu: FunctionComponent<{icon?: IconProps}> = ({ icon = <LanguageIcon /> }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );
  const [language, setLanguage] = useState(i18n.language);
  const [anchorEl, setAnchorEl] = useState(null);
  const [languages, setLanuages] = useState(i18n.store.options.ilanguages);

  const open = Boolean(anchorEl);

  const getLanguageLabel = () => {
    let _languages = _.keyBy(languages, 'languageid');
    return _languages[language].name

  };
  const handleMenu = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    handleClose();
    window.location.reload();
  };

  return (
    <div>
      <Tooltip title={t('')}>
        <IconButton
          aria-label={t('auth.user_menu')}
          aria-owns={open ? 'menu-appbar' : null}
          aria-haspopup={true}
          color="inherit"
          onClick={handleMenu}
          size="large">
          {icon}
          <div className={classes.languageLabel}>{getLanguageLabel()}</div>
        </IconButton>
      </Tooltip>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        {languages.map(item => {
          return <MenuItem key={item.languageid}
            className={classes.menuItem}
            onClick={() => handleChange(item.languageid)}
            component={isXSmall ? 'span' : 'li'}
          >
            {item.name}
          </MenuItem>;
        })}

      </Menu>
    </div>
  );
};

export default LanguageMenu;
